// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkSignOutBase: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 12,
    color1 = "#e00b5a",
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 12 12" width={size} height={size}>
        <path
            fill="currentColor"
            d="M11.89 6.027a.41.41 0 0 0 0-.554l-3-3.143a.364.364 0 0 0-.53 0 .41.41 0 0 0 0 .555l2.36 2.472H4.125a.385.385 0 0 0-.375.393c0 .216.169.393.375.393h6.595L8.36 8.615a.41.41 0 0 0 0 .555.364.364 0 0 0 .53 0zM4.125 1.036A.385.385 0 0 0 4.5.643.385.385 0 0 0 4.125.25h-2.25C.839.25 0 1.129 0 2.214v7.072c0 1.085.84 1.964 1.875 1.964h2.25a.385.385 0 0 0 .375-.393.385.385 0 0 0-.375-.393h-2.25c-.621 0-1.125-.528-1.125-1.178V2.214c0-.65.504-1.178 1.125-1.178z"
        />
    </svg>
);

export default React.memo(LinkSignOutBase);
